var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transaction-reject-message-view"},[_c('transaction-reject-message',_vm._b({attrs:{"card-off":"","continue-to-is-route":""}},'transaction-reject-message',_vm.params,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }